const dev = {
  s3: {
    REGION: 'us-east-1',
    BUCKET: 'enzo-api-prod-attachmentsbucket-m49a4nlrwcm1'
  },
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'https://c6ddsws5ji.execute-api.us-east-1.amazonaws.com/dev'
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_y1nVyUDB7',
    APP_CLIENT_ID: '2j4chs3h3h5cv87820l8m6is4d',
    IDENTITY_POOL_ID: 'us-east-1:493ff613-b8d5-422e-a4d3-e3428ded4e6c'
  }
};

const prod = {
  s3: {
    REGION: 'us-east-1',
    BUCKET: 'enzo-api-dev-attachmentsbucket-gzfd2wpiybh6'
  },
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'https://t1ng1ly16d.execute-api.us-east-1.amazonaws.com/prod'
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_oLMQOtDpe',
    APP_CLIENT_ID: '2j4chs3h3h5cv87820l8m6is4d',
    IDENTITY_POOL_ID: 'us-east-1:0d0e29d8-5790-4942-a451-b66589c1b5ff'
  }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod' ? prod : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};



// WEBPACK FOOTER //
// ./src/config.js